import React from 'react';
import { CheckboxContainer, CheckboxLabel } from '../styles';
import Checkbox from 'components/Buttons/CheckboxButton';
import utils from 'utils';
import { FieldTriggerConfig } from 'models/response';

interface CheckboxInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  feedbackColor: string;
  feedbackMessage: string;
  name: string;
  triggerConfig: FieldTriggerConfig | null;
  executeActionQ1: () => void;
}

export const CheckboxInputComponent: React.FC<CheckboxInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  feedbackColor,
  feedbackMessage,
  name,
  triggerConfig,
  executeActionQ1,
}) => {
  let value = '';
  try {
    value = multi && (index || index === 0) ? field.value.content[index].content : field.value.content[0].content;
  } catch (e) {
    console.error(e);
    utils.app.notify('warning', `Field ${name}:${label} received with a non valid value`, 5000, 'non-valid-value');
  }

  const handleChange = () => {
    if (field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: value === 'true' ? 'false' : 'true',
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  return (
    <CheckboxContainer>
      <CheckboxLabel>{!multi ? label : ''}</CheckboxLabel>
      <Checkbox
        statusColor={feedbackColor}
        feedbackMessage={feedbackMessage}
        name={name}
        isActive={value ? JSON.parse(value) : false}
        action={handleChange}
      />
    </CheckboxContainer>
  );
};
